import { classPrefix } from './class_prefix';

export const visuallyHiddenClassName = `visually-hidden visuallyhidden sr-only ${classPrefix}sr-only`;
